import { FC, useEffect } from 'react';
import Typography from '@components/common/typography';
import VerificationCode from '@components/verification_code';
import styles from './styles.module.scss';
import { hidePhoneNumber } from '@utils/index';
import { apiAuthService } from '@api';
import { useApiMutation } from '@hooks/api/useApiMutation';
import { useTranslation } from 'react-i18next';
import { useLocales } from '@hooks/helpers/useLocales';
import { useApiQuery } from '@hooks/api/useApiQuery';
import { IModalComponentProps } from '@context/modal_context';
import illustration from '@svg/illustrations/sms_sent.svg';

const VerificationPhoneWalletModal: FC<
    IModalComponentProps<{
        phone_code: string;
        phone_number: string;
        secure_id: string;
        code: string;
    }>
> = ({ modalData, changeModalData, handleChangeDisable }) => {
    const { t } = useTranslation('modals', {
        keyPrefix: 'verification_phone'
    });
    const { requestSuccessLocale, requestErrorLocale } = useLocales();

    const { handleRequest: handleResend } = useApiMutation({
        method: () => apiAuthService.sendSecurityCode(),
        onSuccess: (secure_id) => {
            requestSuccessLocale('resent_phone_verification');
            changeModalData({ ...modalData, secure_id, code: '' });
        },
        onError: requestErrorLocale
    });

    useApiQuery({
        method: () => apiAuthService.sendSecurityCode(),
        onSuccess: (secure_id) => {
            requestSuccessLocale('sent_code');
            changeModalData({ ...modalData, secure_id, code: '' });
        },
        isInitialRequest: false,
        onError: requestErrorLocale
    });

    useEffect(() => {
        if (modalData?.code?.length < 5) {
            handleChangeDisable(true);
        } else {
            handleChangeDisable(false);
        }
    }, [modalData]);

    return (
        <div className={styles.wrapper}>
            <img src={illustration} alt="SMS Sent" className={styles.illustration} />
            <Typography variant="h4" className={styles.title}>
                {t('title')}
            </Typography>
            <Typography variant="body3" className={styles.description}>
                {modalData?.phone_code ? (
                    <>
                        {t('to')}{' '}
                        <b>
                            {modalData?.phone_code &&
                                (modalData?.phone_code.includes('+')
                                    ? modalData?.phone_code
                                    : `+${modalData?.phone_code}`)}{' '}
                            {hidePhoneNumber(modalData?.phone_number)}
                        </b>
                    </>
                ) : (
                    t('to_primary')
                )}
            </Typography>
            <div className={styles.content}>
                <VerificationCode
                    onChange={(value) => changeModalData({ ...modalData, code: value })}
                    value={modalData?.code}
                />
                <div>
                    <button onClick={handleResend}>{t('resend')}</button>
                </div>
            </div>
        </div>
    );
};

export default VerificationPhoneWalletModal;
